<div class="unsubscription-container">
    <div class="unsubscription-card">
        <div *ngIf="(loading$ | async) && !loadingPreference" class="loading-state">
            <div class="css-spinner"></div>
            <p>Loading...</p>
        </div>

        <div *ngIf="!((loading$ | async) && !loadingPreference)" class="unsubscription-form">
            <h1>Email Notification Preferences</h1>
            <p class="email-text">Manage your email notification preferences</p>

            <mat-form-field appearance="outline" class="email-input-field">
                <mat-label>Email Address</mat-label>
                <input
                       matInput
                       type="email"
                       id="unsubscription-email-input"
                       name="unsubscriptionEmail"
                       placeholder="Enter your email address"
                       [(ngModel)]="email"
                       #emailInput="ngModel"
                       [disabled]="!!(loading$ | async)"
                       required
                       email />
                <mat-icon matSuffix>email</mat-icon>
                <mat-hint *ngIf="emailInput.pristine || emailInput.valid">Enter the email address you wish to manage preferences for</mat-hint>
                <mat-error *ngIf="emailInput.errors?.['required']">Email address is required</mat-error>
                <mat-error *ngIf="emailInput.errors?.['email']">Please enter a valid email address</mat-error>
            </mat-form-field>

            <div class="existing-customer-section">
                <mat-checkbox
                              id="existing-customer-checkbox"
                              [(ngModel)]="isExistingCustomer"
                              [disabled]="!!(loading$ | async)">
                    I am an existing customer
                </mat-checkbox>
            </div>

            <div class="preference-options"
                 [class.preferences-disabled]="emailInput.invalid || !email || !!(loading$ | async) || !isExistingCustomer">

                <!-- Unsubscribe from All Emails -->
                <label class="preference-card"
                       [class.preference-card--selected]="selectedPreference === 'COMPLETE'"
                       [class.preference-card--disabled]="isOptionDisabled('COMPLETE')"
                       for="radio-unsubscribe-complete">
                    <div class="preference-card-body">
                        <div class="preference-card-text">
                            <span class="preference-title">Unsubscribe from All Emails</span>
                        </div>
                        <input class="pref-radio"
                               type="radio"
                               id="radio-unsubscribe-complete"
                               name="preferenceGroup"
                               value="COMPLETE"
                               [(ngModel)]="selectedPreference"
                               [disabled]="isOptionDisabled('COMPLETE') || emailInput.invalid || !email || !!(loading$ | async)" />
                    </div>
                </label>

                <!-- Unsubscribe from Organization Notifications -->
                <label class="preference-card"
                       [class.preference-card--selected]="selectedPreference === 'ORG_NOTIFICATIONS'"
                       [class.preference-card--disabled]="isOptionDisabled('ORG_NOTIFICATIONS')"
                       for="radio-unsubscribe-org">
                    <div class="preference-card-body">
                        <div class="preference-card-text">
                            <span class="preference-title">Unsubscribe from Organization Notifications</span>
                        </div>
                        <input class="pref-radio"
                               type="radio"
                               id="radio-unsubscribe-org"
                               name="preferenceGroup"
                               value="ORG_NOTIFICATIONS"
                               [(ngModel)]="selectedPreference"
                               [disabled]="isOptionDisabled('ORG_NOTIFICATIONS') || emailInput.invalid || !email || !!(loading$ | async)" />
                    </div>
                </label>

                <!-- Unsubscribe by Event/Subscription (Merged) -->
                <label class="preference-card"
                       [class.preference-card--selected]="selectedPreference === 'EVENT_TYPE'"
                       [class.preference-card--disabled]="isOptionDisabled('EVENT_TYPE')"
                       for="radio-unsubscribe-event-type">
                    <div class="preference-card-body">
                        <div class="preference-card-text">
                            <span class="preference-title">Unsubscribe Event: {{ eventTypeDisplayName }}</span>
                        </div>
                        <input class="pref-radio"
                               type="radio"
                               id="radio-unsubscribe-event-type"
                               name="preferenceGroup"
                               value="EVENT_TYPE"
                               [(ngModel)]="selectedPreference"
                               [disabled]="isOptionDisabled('EVENT_TYPE') || emailInput.invalid || !email || !!(loading$ | async)" />
                    </div>
                </label>

            </div>

            <div class="submit-actions">
                <material-button
                                 id="btn-submit-preference"
                                 text="Submit"
                                 color="primary"
                                 [loading]="!!(loading$ | async)"
                                 [disabled]="emailInput.invalid || !email || !!(loading$ | async) || (isExistingCustomer && !selectedPreference) || (isExistingCustomer && selectedPreference === submittedPreference)"
                                 (buttonClicked)="onSubmit()">
                </material-button>
            </div>
            <div *ngIf="success$ | async" class="inline-success-banner">
                <mat-icon class="inline-success-icon">check_circle</mat-icon>
                <span>Preferences updated successfully. Lower level preferences have been disabled.</span>
            </div>

        </div>


    </div>
</div>
